// Numbered instruction card (Run of Show + guided assembly sub-steps).
export default function StepCard({ number, title, duration, body, say, subSteps = [] }) {
  return (
    <div className="rounded-2xl bg-white border border-brand-navy/10 pib-shadow-sm p-4 sm:p-5">
      <div className="flex items-start gap-3 sm:gap-4">
        <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-brand-orange text-white font-display text-xl flex items-center justify-center">
          {number}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <h3 className="display-title text-lg sm:text-xl text-brand-navy">{title}</h3>
            {duration && (
              <span className="inline-flex items-center rounded-full bg-brand-navy/5 px-2.5 py-0.5 text-xs font-semibold text-brand-navy/70">
                {duration}
              </span>
            )}
          </div>
          {body && <p className="mt-1.5 text-[15px] leading-snug text-brand-navy/80">{body}</p>}
          {say && (
            <div className="mt-3 rounded-xl bg-brand-cream border-l-4 border-brand-orange px-4 py-3">
              <p className="text-xs font-bold uppercase tracking-wide text-brand-orange mb-0.5">Say this</p>
              <p className="text-[15px] leading-snug text-brand-navy italic">“{say}”</p>
            </div>
          )}
          {subSteps.length > 0 && (
            <ol className="mt-3 space-y-2">
              {subSteps.map((s, i) => (
                <li key={i} className="flex gap-2.5 rounded-xl bg-brand-navy/5 px-3 py-2.5">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-navy text-white text-xs font-bold flex items-center justify-center mt-0.5">
                    {i + 1}
                  </span>
                  <span className="text-[14px] sm:text-[15px] leading-snug text-brand-navy">{s}</span>
                </li>
              ))}
            </ol>
          )}
        </div>
      </div>
    </div>
  );
}
